const dictionary = {
    httpCode: {
        name: "状态码错误",
        data: [
            ["400", ["请求错误(400)", "request error 400"]],
            ["401", ["未授权，请重新登录(401)"]],
            ["403", ["拒绝访问(403)"]],
            ["404", ["请求出错(404)"]],
            ["408", ["请求超时(408)"]],
            ["500", ["服务器错误(500)"]],
            ["501", ["服务未实现(501)"]],
            ["502", ["网络错误(502)"]],
            ["504", ["网络超时(504)"]],
            ["505", ["HTTP版本不受支持(505)"]],
            ["noResponse", ["服务器未响应"]],
            ["default", ["连接出错"]],
            ["program", ["暂无数据"]]
        ]
    },
    language: {
        name: "语言",
        data: [
            ["zh", ["中文"]],
            ["en", ["英文"]]
        ]
    },
    common:{
        name:"常用",
        data:[
            ["Y", ["是"]],
            ["N", ["否"]],
            ["SUCCESS", ["成功"]],
            ["SUCCESSFUL", ["成功"]],
            ["FAIL", ["失败"]],
            ["FAILURE", ["失败"]]
        ]
    }
};
let languageNumber;
const replace = {
    setLanguage(la) {
        if (isNaN(la)) {
            la = getIndex("language", la)
        }
        if (la === -1) return false;
        languageNumber = la;
        return true
    },
    getLanguage() {
        return languageNumber
    },
    getValue(key, pkey) {
        if (typeof key !== 'string' && typeof key !== 'number') return "";
        key = String(key);
        if (!key) return "";
        if (typeof pkey !== 'string' && typeof pkey !== 'number') return key;
        pkey = String(pkey);
        if (!pkey) return key;
        const obj = replace[pkey];
        if (!obj) return key;
        return typeof obj[key] === "undefined" ? key : obj[key]
    }
};

function getIndex(key, value) {
    if (dictionary.hasOwnProperty(key)) {
        const cur = dictionary[key].data;
        for (let i = 0; i < cur.length; i++) {
            if (cur[i][0] === value) return i
        }
    }
    return -1
}

(function () {
    replace.setLanguage("zh");
    let languageNumber = replace.getLanguage();
    for (let key in dictionary) {
        if (dictionary.hasOwnProperty(key)) {
            const cur = dictionary[key].data;
            replace[key] = {};
            for (let i = 0; i < cur.length; i++) {
                replace[key][cur[i][0]] = cur[i][1][languageNumber] || ""
            }
        }
    }
})();
export default replace
export const {httpCode} = replace;
